import useTheme from "@mui/material/styles/useTheme";
import { makeStyles } from "@mui/styles";

export const useCustomStyle = makeStyles(() => {
  const theme = useTheme();
  return {
    PermissionAssignatationWrapper: {
      "&.PermissionAssignatation": {
        padding: "0 10px 0 15px",
        width: "100%",
        "& .permissiontophead": {
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          alignItems: "center",
          marginTop: "15px",
        },
        "& .permissionTableContainer": {
          paddingTop: "30px",
          "& .permissionTable": {
            "& .tableHeader": {
              background: "#F3FAFF",
            },
            "& .categoryPermissionRow": {
              "& td": {
                "&:first-child": {
                  paddingLeft: "40px",
                  position: "sticky",
                  left: 0,
                  background: "#ffffff",
                  zIndex: 1,
                },
              },
            },
            "& .categoryNameRow": {
              "& td": {
                background: "#f7f7f9",
                "&:first-child": {
                  paddingLeft: "10px",
                  position: "sticky",
                  left: 0,
                  background: "#f7f7f9",
                  zIndex: 1,
                },
              },
              "&.disabledColumn": {
                "& td": {
                  opacity: 0.6,
                  pointerEvents: "none",
                },
              },
            },
            "& .moduleHeading": {
              "& td": {
                //theme.palette.customColor.BGWEAK,
                "&:first-child": {
                  paddingLeft: "10px",
                  position: "sticky",
                  left: 0,
                  background: "#ffffff",
                  zIndex: 1,
                  "& h5": {
                    color: "#1199e4",
                  },
                },
              },
            },
            "& thead": {
              "& th": {
                border: `1px solid ${theme.palette.customColor.LINE}`,
                position: "relative",
                padding: "0px 10px",
                "&:first-child": {
                  position: "sticky",
                  left: 0,
                  background: "#ffffff",
                  zIndex: 1,
                  width: "190px",
                },
                "& .moreIcon": {
                  position: "absolute",
                  top: 10,
                  right: 10,
                  padding: "2px",
                },
              },
            },
            "& td": {
              background: theme.palette.customColor.LIGHT,
              border: `1px solid ${theme.palette.customColor.LINE}`,
              padding: "0 0 0 10px",
              textAlign: "center",
              "&:first-child": {
                textAlign: "left",
              },
              "& .Mui-checked": {
                "& svg": {
                  "& path": {
                    fill: theme.palette.customColor.PRIMARY,
                  },
                },
              },
              "& .Mui-disabled": {
                opacity: 0.3,
              },
            },
            "& .disabledColumn": {
              background: theme.palette.customColor.BGWEAK,
            },
          },
        },
        "& .addButton": {
          padding: 0,
          top: "-20px",
          right: "-1px",
          position: "absolute",
          borderRadius: "0",
          background: "#1a1a1a",
          color: "#fff",
          "&:hover": {
            background: "#1a1a1a",
          },
          "& svg": {
            fontSize: "20px",
          },
        },
      },
    },
  };
});
